<template>
  <div class="box1 boxYl">
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <div class="box1 bgbox">
            <div class="time_box dn-content-bg">
              <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
              </time-search>

            </div>
            <div class="contant_box setHeight dn-content-bg">
              <div class="barTop">
                <div class="top">负载率时间百分比</div>
                <div class="bottom">(各种负载率累计时间/月统计时间)</div>
              </div>
              <div class="barCenten">
                <el-carousel height="100%" :autoplay="false" @change="carouselChange">
                  <el-carousel-item v-for="(item,index) in pieData" :key="index">
                    <div style="height:100%;width:100%" v-if="item.length>1">
                      <el-col :span="12" class="dn-content-bg" style="padding-left:0;padding-right:10px;">
                        <guan :pie="item[0]" :carouselIndex="carouselIndex"></guan>
                      </el-col>
                      <el-col :span="12" class="dn-content-bg" style="padding-left:0;padding-right:10px;">
                        <guan :pie="item[1]" :carouselIndex="carouselIndex"></guan>
                      </el-col>
                    </div>
                    <div style="height:100%;width:100%" v-else>
                      <el-col :span="24" class="dn-content-bg" style="padding-left:0;padding-right:10px">
                        <guan :pie="item[0]" :carouselIndex="carouselIndex"></guan>
                      </el-col>dian
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="barbottom">
                <el-col :span="24" class="barTopleft">
                  <nk-table :showPage="false" :columns="columns" :height="400" :data="tableData" style="height: 100%;
                    overflow: auto;"></nk-table>
                </el-col>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
let vm
import TabTree from '@/components/common/TabTree.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import NkTable from '@/components/common/NkTable'
import Guan from './pages/guan'
import * as utils from '@/utils/index.js'
import * as handleData from '@/utils/handleData.js'
import * as fpg from '@/utils/fpg.js'
import tree from '@/utils/tree.js'
import { isNull, isUndefined } from 'util'
import dateTool from '@/utils/dateTool'
export default {
  data () {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      columns: [{ prop: 'transformer', width: 200, label: '变压器' }],
      tableData: [],
      // checkedKeys: [],
      treeData: {},
      timeData: [
        {
          type: 'month',
          label: '月',
        },
      ],
      dataType: '0',
      pieOne: {
        title: '1#变压器',
        titleTime: '1#变压器',
        legend: [],
        data: [],
      }, //饼图数据用量
      pieTwo: {
        title: '2#变压器',
        titleTime: '2#变压器',
        legend: [],
        data: [],
      }, //饼图数据用量
      pointCode: '100229',
      pointNumber: '0',
      measureIds: [], //计量点
      apiArr: [],
      pieData: [],
      carouselIndex: 0,
      selectedDate: {},
    }
  },
  created () {
    vm = this
    vm.init()
  },
  mounted () { },
  activated () { },
  watch: {},
  methods: {
    init () {
      let vm = this
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        vm.$store.state.user.currentCompanyId,
        '/nyyh/transformerLoadRatio',
        ''
      )
        .then((res) => {
          let measureIds = utils.findDataByParam('param', true, res.data)
          vm.pieData = []
          vm.tableData = []
          measureIds.forEach((item, key) => {
            vm.measureIds.push(item.value)
            vm.tableData.push({
              transformer: item.param,
            })
            if (key % 2 == 0) {
              vm.pieData.push([])
            }
            vm.pieData[parseInt(key / 2)].push({
              title: item.param,
              titleTime: item.param,
              legend: [],
              data: [],
              measureIds: item.value,
            })
          })
          let time = new Date()
          let startTime = dateTool.format(time, 'yyyy-MM') + '/01 00:00:00'
          time.setMonth(time.getMonth() + 1)
          let endTime = dateTool.format(time, 'yyyy-MM') + '/01 00:00:00'
          vm.selectedDate = {
            dataType: '1',
            dateType: 'month',
            endTime: endTime,
            startTime: startTime,
          }
          console.log(vm.pieData, 'pieData')
          vm.TimeControlClick(vm.selectedDate)
        })
    },
    timeControlChange () { },
    //查询事件
    TimeControlClick (e) {
      let xData = []
      vm.selectedDate = e
      vm.getEDate(e)
    },
    //获取数据
    async getEDate (elem) {
      let tableData = JSON.parse(JSON.stringify(vm.tableData))
      let res = await vm.$api.predict.puzzleLoadFactorAreaCountStatics(
        vm.measureIds,
        vm.selectedDate.startTime,
        vm.selectedDate.endTime
      )
      let columns = []
      vm.columns = [{ prop: 'transformer', width: 200, label: '变压器' }]
      res.data[0].areaData.forEach((item) => {
        columns.push({
          prop: item.area,
          label: item.area,
        })
      })
      vm.pieData.map((item) => {
        item.map((temp) => {
          temp.legend = []
          temp.data = []
        })
      })
      res.data.forEach((temp, i) => {
        let flag = vm.pieData[parseInt(i / 2)].find(
          (item) => item.measureIds == temp.measureId
        )
        temp.areaData.forEach((items, j) => {
          flag.legend.push(items.area)
          flag.data.push({
            name: items.area,
            value: items.value,
          })
          tableData[i][items.area] = items.value
        })
      })
      vm.columns = vm.columns.concat(columns)
      vm.tableData = tableData
      vm.carouselChange(-1)
    },
    carouselChange (index) {
      //走马灯切换时触发
      this.carouselIndex = index
    },
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
  },
  components: { TimeSearch, Guan, NkTable },
}
</script>
<style lang="scss" >
.boxYl {
  .el-table th,
  .el-table tr {
    background-color: #fff;
    height: 50px;
  }
}
</style>
<style lang="scss" scoped>
.box1 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  //   background: #f5f5f5;
  padding: 14px;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.el-col {
  //   border-radius: 4px;
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.treecontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  box-sizing: border-box;
}

.bgbox {
  position: relative;
  padding-top: 0;
  box-sizing: border-box;
  padding: 0;
}
.time_box {
  width: 100%;
  padding: 0px;
  box-sizing: border-box;
  //   background: #fff;
}
::v-deep .time-warp label {
  color: #2e3842 !important;
}
.contant_box {
  //   background: #fff;
  /* top: 78px; */
  /* bottom: 0px; */
  /* left: 0px; */
  /* right: 0px; */
  padding: 14px;
  padding-bottom: 0px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: auto;
  height: 90%;
  margin-top: 14px;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}
.barTop {
  height: 17%;
  display: flex;
  flex-flow: column;
  align-items: center;
  border-top: 1px solid #ededed;
  justify-content: center;
  .top {
    font-size: 22px;
    color: rgba(118, 119, 120);
    font-weight: 600;
  }
  .bottom {
    font-size: 19px;
    color: #767778;
    font-weight: 600;
    margin-top: 5px;
  }
}
.barCenten {
  height: 43%;
  display: flex;
  // overflow: auto;
}
.barTopleft {
  padding-left: 0;
  padding-right: 10px;
}
.barTopright {
  padding-left: 10px;
  padding-right: 0;
}
.barbottom {
  height: 34%;
  margin-top: 20px;
}
</style>
<style scoped>
.el-carousel--horizontal {
  overflow-x: hidden;
  height: 100%;
  width: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.box >>> .el-carousel__button {
  display: block;
  opacity: 0.48;
  background-color: #fff;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  /* background: pink !important; */
  background: rgba(122, 194, 233);
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
.box >>> .el-carousel__indicator.is-active button {
  opacity: 1;
  background: rgba(0, 56, 140) !important;
}
</style>
